import { Component, ElementRef, Host, Signal, ViewChild } from '@angular/core';
import { TextsControllerComponent } from '../../texts-controller/texts-controller.component';
import { property } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { OnlineModeService } from '@core/services/online-mode.service';

@Component({
  selector: 'ms-texts-screen-play',
  templateUrl: './texts-screen-play.component.html',
  styleUrls: ['./texts-screen-play.component.scss'],
  standalone: false,
})
export class TextsScreenPlayComponent {
  @ViewChild('textContainer')
  get textContainerRef(): ElementRef<HTMLElement> {
    return this.textsController.textContainerRef;
  }

  set textContainerRef(value: ElementRef<HTMLElement>) {
    this.textsController.textContainerRef = value;
  }

  /**
   * HTML-элементы абзацев.
   *
   * Оформлены через геттеры и сеттеры, так как при изменении значения,
   * полученного от `ViewChild` надо вызвать метод `generate` для применения
   * трансформаций к абзацам.
   */
  @ViewChild('textParagraphs')
  get paragraphsRef(): ElementRef<HTMLElement> {
    return this.textsController.paragraphsRef;
  }

  set paragraphsRef(value: ElementRef<HTMLElement>) {
    this.textsController.paragraphsRef = value;
  }

  /**
   * HTML-элементы заголовка текста.
   *
   * Оформлены через геттеры и сеттеры, так как при изменении значения,
   * полученного от `ViewChild` надо вызвать метод `generate` для применения
   * трансформаций к абзацам.
   */
  @ViewChild('textTitle')
  set titleRef(value: ElementRef<HTMLElement>) {
    this.textsController.titleRef = value;
  }

  get titleRef(): ElementRef<HTMLElement> {
    return this.textsController.titleRef;
  }

  get containOrCoverWeb(): 'cover' | 'contain' {
    return this.paragraphsRef?.nativeElement?.offsetHeight >= 700 ? 'contain' : 'cover';
  }

  private _titleRef?: ElementRef<HTMLElement> = undefined;

  @ViewChild('secondPage') secondPage!: ElementRef<HTMLElement>;

  @ViewChild('firstPage') firstPage!: ElementRef<HTMLElement>;

  readonly forbiddenProperties: (string | symbol)[] = []; // ['textContainerRef', 'paragraphsRef'];
  readonly forceProperties: (string | symbol)[] = ['__ngContext__'];

  get isRemotePlayer(): Signal<boolean> {
    return this._onlineModeService.isRemotePlayer;
  }

  constructor(
    @Host() public readonly textsController: TextsControllerComponent,
    private readonly _toastrService: ToastrService,
    private readonly _translateService: TranslateService,
    private readonly _onlineModeService: OnlineModeService,
  ) {
    return new Proxy(this, {
      get: (target, property, receiver) => {
        if (
          this.forceProperties.includes(property) ||
          (!this.forbiddenProperties.includes(property) && property in target)
        ) {
          return target[property];
        }
        return this.textsController[property];
      },
      set: (target, property, value, receiver) => {
        if (
          this.forceProperties.includes(property) ||
          (!this.forbiddenProperties.includes(property) && property in target)
        ) {
          target[property] = value;
          return true;
        }
        this.textsController[property] = value;
        return true;
      },
    });
  }

  public showConverterError(): void {
    this._toastrService.error(
      this._translateService.instant('speedreading.convertToPdf.blindingText.deny'),
      this._translateService.instant('baseToastr.error'),
    );
  }
}
